export const useAppVersion = (): string =>
  process.env.REACT_APP_VERSION ?? "0.0.0";
